module.exports = __webpack_public_path__ + "assets/img/qywh_img4.ab047f4f.png";